import Api from '../Api/Api';

let cachedKey = null;
let pending = null;

/**
 * Carrega a chave da API do Google Maps. A chave é armazenada em cache para evitar chamadas repetidas.
 * @returns {Promise<string>} Uma promessa que resolve com a chave da API do Google Maps.
 */
export function loadGmapsApiKey() {
  if (cachedKey) return Promise.resolve(cachedKey);
  if (pending) return pending;

  const api = new Api();
  pending = api
    .getParamAsync('Accounts/maps-api-key', {})
    .then((response) => {
      const key = response && response.data && response.data.key;
      if (!key) {
        throw new Error('Google Maps API key is not configured');
      }
      cachedKey = key;
      return key;
    })
    .catch((error) => {
      pending = null;
      throw error;
    });

  return pending;
}
